module.exports = __webpack_public_path__ + "img/herb-lavender-190x100.9a47f7e5.jpg";